module.exports = __webpack_public_path__ + "static/media/ABA.0c4bddad.png";